'use client'
import Script from 'next/script'
import { useEffect } from 'react'

interface GoogleMapsLoaderProps {
	apiKey: string
}

const GoogleMapsLoader: React.FC<GoogleMapsLoaderProps> = ({ apiKey }) => {
	useEffect(() => {
		if (typeof window !== 'undefined') {
			if (typeof window.HTMLDialogElement !== 'function') {
				class DialogPolyfill extends HTMLElement {
					constructor() {
						super()
					}

					showModal() {
						this.style.display = 'block'
						this.setAttribute('open', '')
					}

					close() {
						this.style.display = 'none'
						this.removeAttribute('open')
					}

					get open() {
						return this.hasAttribute('open')
					}

					set open(value) {
						if (value) {
							this.setAttribute('open', '')
							this.style.display = 'block'
						} else {
							this.removeAttribute('open')
							this.style.display = 'none'
						}
					}
				}

				window.HTMLDialogElement = DialogPolyfill as any
			}
		}
	}, [])

	return (
		<Script
			src={`https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`}
			strategy="afterInteractive"
			async
		/>
	)
}

export default GoogleMapsLoader
